import {FEEDBACK_360_SURVEY} from "../../../../../config/questionTypeConstants"
import { deepCopy } from "../../../../utils/deepCopy";
import {ERROR_MESSAGE_DRAG_IMPROVEMENT, ERROR_MESSAGE_DRAG_NUMBER, ERROR_MESSAGE_DRAG_STRENGTH} from "../../../reducers/SurveyAnsweringPageReducer/constants"

export const behaviourDragUpdate = (state,payload)=>{
    let pageBreakCopy = deepCopy(state.pageBreakAddedQuestionSet)
    let pageIndex =pageBreakCopy[state.currentIndex]
    if(pageIndex.goalId=== FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG_180 || pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG_180 ){
    let answeredQuestionDetails = pageIndex.questions[0];
    let questionCount = 0
    if (answeredQuestionDetails) {
        for (const key in answeredQuestionDetails) {
            if (answeredQuestionDetails[key].questions && Array.isArray(answeredQuestionDetails[key].questions)) {
                questionCount += answeredQuestionDetails[key].questions.length;
            }
        }
        if(questionCount<3){
            if(pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG_180){
              return { ...state, errorText: ERROR_MESSAGE_DRAG_STRENGTH, hideErrorBlock: false }}
            else if(pageIndex.goalId=== FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG_180){
             return { ...state, errorText: ERROR_MESSAGE_DRAG_IMPROVEMENT, hideErrorBlock: false }}
        }
        else{
            return{...state, errorText:"", hideErrorBlock:true}
        }
    }
    else{
        if(pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.STRENGTH_DRAG_180){
            return { ...state, errorText: ERROR_MESSAGE_DRAG_STRENGTH, hideErrorBlock: false }}
          else if(pageIndex.goalId=== FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG || pageIndex.goalId === FEEDBACK_360_SURVEY.IMPROVEMENT_DRAG_180){
           return { ...state, errorText: ERROR_MESSAGE_DRAG_IMPROVEMENT, hideErrorBlock: false }}
    }
}
}